import { createFormAction } from 'redux-form-saga'

export const CUSTOMER_DOC_FORM_KEY = 'CUSTOMER_DOC_FORM'
export const CustomerDocFormAction = createFormAction(CUSTOMER_DOC_FORM_KEY)

